// initial state is what the object looks like before we load in the json data, we do this to prevent errors
export default {
    blob: {
        render: "",
        logo: "",
        levels: []
    },
    selectedLevel: {
        apartments: {}
    },
    hovered: null,
    levelHover: null
};


// WEBPACK FOOTER //
// ./src/reducers/initialState.js